/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as AccessDefs from "./defs.defs.js";

const $nsid = "place.stream.access.createGrant";

export { $nsid };

export const $params = /*#__PURE__*/ l.params();

export type $Params = l.InferOutput<typeof $params>;

export const $input = /*#__PURE__*/ l.jsonPayload({"subject":/*#__PURE__*/ l.string(),"role":/*#__PURE__*/ l.ref<AccessDefs.Role>((() => AccessDefs.role) as any),"note":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":1000,"maxGraphemes":100}))});

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>;
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>;

export const $output = /*#__PURE__*/ l.jsonPayload({"grant":/*#__PURE__*/ l.ref<AccessDefs.GrantView>((() => AccessDefs.grantView) as any)});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Grant a role to an account. Requires the admin role. Idempotent: granting a role an account already holds returns the existing grant. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, ["Unauthorized","InvalidSubject","InvalidRole"]);

export { main };

export const $lxm = $nsid;
